<div class="row">
    <div class="col-6">
        <h1><span *ngIf="!editData">Cotización</span><small *ngIf="editData">Editando contrato #{{ editData.id }}</small></h1>
    </div>
    <div class="col-6 ">
        <div style="text-align: right" *ngIf="!editData">
          <button type="button" class="btn btn-secondary" (click)="emptyDataStore()">
              Vaciar
          </button>
        </div>
      </div>
</div>

<form [formGroup]="quotationForm" class="form-horizontal" (keydown.enter)="$event.preventDefault()">
<div class="row">
    <div class="col-md-8 mb-4">
        <div class="card  full-height">
            <div class="card-body">
                    <div class="row">
                        <div class="col-md-6">
                            <label class="form-labels mt-2">Cantidad de Prestamo</label>
                            <div class="input-group flex-nowrap">
                                <img class="input-group-text" width="40" src="./assets/icons/dollar.svg" />
                                <input (change)="checkFields()" type="number" formControlName="cantidad" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-labels mt-2">Interes</label>

                            <div class="input-group flex-nowrap">
                                <input type="number" (change)="checkFields()" class="form-control" formControlName="tasaInteresAnual">
                                <span class="input-group-text">%</span>
                                <!-- <img class="input-group-text" width="40" src="./assets/icons/dollar.svg" /> -->
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label class="form-labels mt-4">Termino (meses)</label>
                            <input type="number" (change)="checkFields()" class="form-control" formControlName="termino">
                        </div>

                        <div class="col-md-6">
                            <label class="form-labels mt-4">Fecha de efectividad</label>
                            <input  (change)="checkFields()" type="date" formControlName="prestamoInicio" class="form-control">
                        </div>

                        <div class="col-md-6">
                            <label class="form-labels mt-4">Fecha de primer pago</label>
                            <input  (change)="checkFields()" type="date" class="form-control" formControlName="firstPayment">
                        </div>
                        <div class="col-md-6">
                            <label class="form-labels mt-4">Tipo de Financiamiento</label>
                            <select (change)="checkFields()" class="form-select" formControlName="loanType">
                                <option value="Prestamo Personal">Prestamo Personal</option>
                                <option value="Financiamiento de Enseres">Financiamiento de Enseres</option>
                                <option value="Credit Loan">Credit Loan</option>
                            </select>
                        </div>
                    </div>
                    
                    
            </div>
        </div>
    </div>
    <div class="col-md-4 mb-4">
        <div class="card  full-height">
            <div class="card-body">
            <div class="row quote-res">
                <div class="col-12">
                    <label class="form-labels">Cantidad de Prestamo</label>
                     <br/><span class="amounts">{{otherValues.cantidad | currency}}</span>
                </div>
                <div class="col-12 mt-4">
                    <label class="form-labels">Interes</label>
                     <br/><span class="amounts">{{otherValues.tasaInteresAnual}}%</span>
                </div>
                <div class="col-12 mt-4">
                    <label class="form-labels">Interes a pagar</label>
                     <br/><span class="amounts">{{amortizationValues.totalInterest | currency}}</span>
                </div>
                <div class="col-12  mt-4"  >
                    <label class="form-labels">Total a pagar</label>
                     <br/><span class="amounts">{{amortizationValues.totalPaid | currency}}</span>
                </div>
                <div class="col-12 mt-4">
                    <label class="form-labels">Pago mensual</label>
                     <br/><span class="amounts">{{otherValues.cantidadPagoMensual | currency }}</span>
                </div>
            </div>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                    <thead>
                        <tr>
                        <th scope="col">Fecha de pago</th>
                        <th scope="col">Balance</th>
                        <th scope="col">Pago</th>
                        <th scope="col">Principal</th>
                        <th scope="col">Interes</th>
                        <th scope="col">Balance Pendiente</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let payment of amortization">
                            <td><strong>{{ payment.thisDate | date:'mediumDate' }}</strong></td>
                            <td>{{ payment.thisBeginningBalance | currency }}</td>
                            <td>{{ payment.thisPaymentAmount | currency  }}</td>
                            <td>{{ payment.thisPaidToPrincipal | currency }}</td>
                            <td>{{ payment.thisPaidToInterest | currency }}</td>
                            <td>{{ payment.thisEndingBalance | currency }}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12" style="text-align: right;">
        <button type="button" [disabled]="quotationForm.invalid" (click)="createContract()" class="btn btn-primary mt-4">Continuar</button>
        <!-- <div *ngIf="showMsg" style="color:rgb(255, 62, 62)">{{ msg }}</div> -->
    </div>
</div>
</form>

